<template>
  <div
    v-if="attrs.images.length > 0"
    class="grid w-full"
    :style="{
      gridTemplateColumns: `repeat(${attrs.columns}, 1fr)`,
      gap: `${attrs.gap}px`,
    }"
  >
    <figure
      v-for="(image, index) in attrs.images"
      :key="image.src"
      class="relative cursor-pointer overflow-hidden rounded"
      :style="{ aspectRatio: attrs.aspectRatio || 'auto' }"
      @click="openLightbox(index)"
    >
      <img
        :src="image.src"
        :alt="image.alt"
        :title="image.title"
        class="block h-full w-full select-none object-cover"
      />
      <figcaption
        v-if="attrs.captions && image.caption"
        class="absolute bottom-0 left-0 m-0 w-full bg-black/50 p-2 text-center text-white"
      >
        {{ image.caption }}
      </figcaption>
    </figure>

    <!-- Vue Easy Lightbox -->
    <VueEasyLightbox
      :visible="lightboxVisible"
      :imgs="lightboxImages"
      :index="lightboxIndex"
      @hide="closeLightbox"
    />
  </div>
</template>

<script setup lang="ts">
import type { NodeProps } from './RenderNode.vue';
import { computed, ref } from 'vue';
import { getGalleryAttrs } from '../extensions/Gallery/GalleryExtension';

const props = defineProps<NodeProps>();
const attrs = computed(() => getGalleryAttrs(props.node.attrs));

// Refs
const lightboxVisible = ref(false);
const lightboxIndex = ref(0);

// Computed
const lightboxImages = computed(() =>
  attrs.value.images.map((image) => ({
    src: image.src,
    title: image.caption || image.title || image.alt || '',
  })),
);

// Methods
const openLightbox = (index: number) => {
  lightboxIndex.value = index;
  lightboxVisible.value = true;
};

const closeLightbox = () => {
  lightboxVisible.value = false;
};
</script>
